import styled from 'styled-components';
import { connect } from 'react-redux';

import { type ThemeName } from '@soomo/lib/styles/themes/index';
import { type CoverManifest } from '@soomo/lib/types/WebtextManifest';

import { RootState } from '~/store';
import { PrintCoverConfig } from '~/types';
import { isCoursePresentInConfig } from '~/types/signup_config';
import Preview from './Preview';

export interface Props {
	showPrint: boolean;
	showLMSWarning?: boolean;
	themeName?: ThemeName;
	coverManifest?: CoverManifest;
	printCoverConfig?: PrintCoverConfig;
}

const Container = (props: Props) => {
	const { showPrint, showLMSWarning, themeName, coverManifest, printCoverConfig } = props;

	return (
		<WebtextPreviewStyles className="webtext-preview">
			{showLMSWarning ? (
				<LMSWarning>
					<img id="lms-warning" src="/images/u_turn.png" />
				</LMSWarning>
			) : (
				<Preview
					showPrint={showPrint}
					themeName={themeName}
					coverManifest={coverManifest}
					printCoverConfig={printCoverConfig}
				/>
			)}
		</WebtextPreviewStyles>
	);
};

export default connect((state: RootState): Props => {
	if (state.app.currentStep === 'lms_school') {
		return { showLMSWarning: true, showPrint: false };
	}

	const showPrint =
		state.app.currentStep?.indexOf('print') !== -1 ||
		state.app.currentStep?.indexOf('shipping') !== -1 ||
		state.app.config.path_type === 'print_purchase';

	if (isCoursePresentInConfig(state.app.config)) {
		return {
			showPrint,
			themeName: state.app.config.course.webtext.theme_name,
			coverManifest: state.app.config.course.webtext.cover_manifest,
			printCoverConfig: state.app.config.course.print.cover_config
		};
	}

	return { showPrint };
})(Container);

const WebtextPreviewStyles = styled.div`
	height: 100%;
	.webtext-preview {
		max-height: 100%;
	}
`;

const LMSWarning = styled.div`
	background: linear-gradient(to right, #b7cbce 0%, #e2cab9 100%);
	border-radius: 4px;
	border: 4px white;
	height: 100%;
	width: 100%;
	overflow: hidden;
	position: relative;

	img {
		opacity: 1;
		width: 256px;
		height: 256px;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
	}
`;
